export type Locale = "zh" | "en";

const wifiAnswer = {
  zh: "长按yoyo顶部按钮 3秒，设备进入配网模式（呼吸灯蓝色闪烁）。在App首页点击「绑定设备」，按提示选择家庭 Wi-Fi 并输入密码即可完成连接。",
  en: "Press and hold the top button of yoyo for 3 seconds to enter pairing mode (blue breathing light). On the App home page, tap Bind Device, select your home Wi-Fi, and enter the password to complete setup.",
};

export const lang = {
  zh: {
    common: {
      buyNow: "立即购买",
      viewProducts: "查看产品",
      shopNow: "立即选购 >",
      menu: "菜单",
      hotline: "热线",
      email: "邮箱",
      address: "地址",
    },
    nav: {
      products: "产品",
      support: "支持",
      about: "关于我们",
      yoyo: "yoyo",
      threeInOne: "三合一",
      faq: "常见问题",
      contact: "联系我们",
      manual: "产品说明书",
      privacy: "隐私政策",
      refund: "退款政策",
      langZh: "中文",
      langEn: "English",
      switchToEn: "English",
      switchToZh: "中文",
    },
    home: {
      heroTitle: "为 0-3 岁宝宝 家庭打造，懂情绪、会记忆，陪宝宝一起成长",
      ourProducts: "我们的产品",
      brandHeadline: "我们承接情绪，但不占有情绪。",
      brandPhilosophy:
        "我们相信，科技应该服务于家庭的情感连接。YOYO 不是冰冷的机器，而是懂情绪、会记忆的陪伴伙伴。我们承接情绪，但不占有情绪——每一次互动，都会让它更懂这个家庭。",
      feature1Title: "每一次互动，都会让它更懂这个家庭。",
      feature2Title: "我们不追求高功耗、高性能和强互动。",
      brandCertTitle: "品牌介绍，品牌证书",
      brandCertSubtitle: "标题",
      certificate: "证书",
      companyIntro: "公司介绍",
      heroSlide2Title: "懂情绪、会记忆，陪宝宝一起成长",
      categorySectionTitle: "找到最适合宝宝的陪伴",
      categoryYoyo: "yoyo 一代",
      categoryYoyoDesc: "智能陪伴机",
      categoryThreeInOneDesc: "家庭场景组合",
      categoryApp: "YOYO App",
      categoryAppDesc: "成长记录与进化",
      categorySupport: "售后支持",
      categorySupportDesc: "FAQ 与产品手册",
      featuresSectionTitle: "yoyo 智能陪伴核心能力",
      testimonialsTitle: "用户真实评价",
      brandStoryTitle: "为 0-3 岁家庭，打造有温度的 AI 陪伴",
      brandStoryDesc:
        "YOYO 关注宝宝情绪变化，用熟悉的声音讲故事，在每一次互动中更懂这个家庭。我们不追求功能堆砌，而是做长期可信赖的成长伙伴。",
      pressTitle: "媒体报道 & 合作伙伴",
      review1Author: "李女士",
      review1Text: "宝宝很喜欢 yoyo，每天睡前都要听故事，情绪明显更稳定了。",
      review2Author: "王先生",
      review2Text:
        "父母声音克隆功能很打动我们，异地工作时也能给宝宝熟悉的声音陪伴。",
      review3Author: "陈女士",
      review3Text: "App 里的成长记录很清晰，周报和日记帮助我们更好地理解宝宝。",
      review4Author: "张先生",
      review4Text: "做工精致，操作简单，老人也能轻松上手绑定设备。",
      review5Author: "赵女士",
      review5Text: "客服响应很快，配网和售后问题都能及时解决，很放心。",
      review6Author: "刘先生",
      review6Text: "yoyo 不会过度打扰，陪伴感刚刚好，是我们家育儿的好帮手。",
      featSmart: "智能",
      featSmartDesc: "情绪识别 / 习惯记忆 / 家庭适配",
      featVoice: "声音",
      featVoiceDesc: "父母声音讲故事 / 多语言支持",
      featGrowth: "成长",
      featGrowthDesc: "日记 / 周记 / 进化记录",
      featSafety: "安全",
      featSafetyDesc: "数据加密 / 儿童隐私保护",
      featConnect: "连接",
      featConnectDesc: "Wi-Fi 配网 / App 远程管理",
      featService: "服务",
      featServiceDesc: "免运费 / 一年质保 / 7×24 支持",
    },
    product: {
      name: "yoyo 一代",
      description: "yoyo 智能陪伴机",
      price: "¥1000.00 CNY",
      details: "详情",
      faqs: "FAQS",
      brandPhilosophy: "品牌理念",
      attributes: "产品属性",
      usageScenarios: "使用场景",
      appGrowth: "APP成长进化记录",
      evolution: "如何进化",
      heroTitle: "yoyo 亲子陪伴机器人",
      heroDesc: "为 0-3 岁宝宝提供情感支持、睡眠安抚和讲故事功能",
      afterSales: "如有售后问题，请联系客服",
      preSaleNote: "预售商品预计 2026 年 8 月 30 日前发货",
      preSale: "预售",
      usdPrice: "$58.65 USD",
      colorOffWhite: "米白色",
      colorSpaceGray: "太空灰",
      sizeS: "一代-S",
      sizeM: "一代-M",
      spec1: "规格1",
      spec2: "规格2",
      spec3: "规格3",
      attrProductSize: "产品尺寸",
      attrPackageSize: "包装尺寸",
      attrProductSizeValue: "120 × 120 × 80 mm",
      attrPackageSizeValue: "200 × 200 × 150 mm",
      listen: "听",
      see: "看",
      speak: "说",
      think: "想",
      move: "动",
      featureEmotionalTitle: "情感陪伴",
      featureEmotionalDesc: "关注宝宝情绪变化，提供温暖陪伴",
      featureStoryTitle: "父母声音讲故事",
      featureStoryDesc: "用熟悉的声音讲故事，给宝宝安全感",
      featureEducationTitle: "自我教育功能",
      featureEducationDesc: "陪伴宝宝认知世界，促进成长",
      appFeature1: "首页进化气泡",
      appFeature2: "日记",
      appFeature3: "周记",
      appFeature4: "宝宝情感管家",
      appFeature5: "家庭关系激活",
      stageRecord: "记录",
      stageRecordDesc: "记录每一次互动与情绪",
      stageUnderstand: "理解",
      stageUnderstandDesc: "理解宝宝的情绪与需求",
      stageRemember: "记住",
      stageRememberDesc: "记住家庭的独特习惯",
      stageFeedback: "反馈",
      stageFeedbackDesc: "给予恰当的反馈与回应",
      stageEvolve: "进化",
      stageEvolveDesc: "持续进化，更懂这个家庭",
    },
    service: {
      freeShipping: "免运费",
      freeShippingDesc: "全国包邮",
      customerService: "客户服务",
      customerServiceDesc: "7×24 在线支持",
      securePayment: "安全支付",
      securePaymentDesc: "多种安全支付方式",
      warranty: "30天退换政策",
      hour24: "24小时内响应",
      warrantyDesc: "一年质保服务",
      customerFirst: "客户优先",
      customerFirstDesc: "以家庭需求为先",
      freeShippingHomeDesc: "全国包邮配送",
    },
    contact: {
      heroAlt: "yoyo 亲子陪伴机器人",
      heroTitle: "yoyo 亲子陪伴机器人",
      heroSubtitle: "yoyo 一直陪伴在你身边，相处越久，越懂你和宝宝。",
      infoTitle: "联系方式",
      messageTitle: "留言",
      hotline: "热线",
      contactLabel: "联系方式：",
      emailLabel: "联系邮箱：",
      addressLabel: "联系地址：",
      address:
        "Tangli, Ma'anshan, Zaozilan'ya Zhengjie, Yuzhong District, Chongqing, China.",
      formEmail: "邮箱",
      formPhone: "手机号",
      formName: "名称",
      formMessage: "信息",
      formSend: "发送",
      formEmailRequired: "请输入邮箱",
      formEmailInvalid: "邮箱格式不正确",
      formPhoneRequired: "请输入手机号",
      formNameRequired: "请输入名称",
      formMessageRequired: "请输入消息内容",
      formSuccess: "消息已发送",
      formError: "消息发送失败",
      formcontactRequired: "请输入联系方式",
      formcontact: "联系方式",
    },
    about: {
      heroAlt: "渝欧城市景观",
      parkAlt: "渝欧跨境数字贸易产业园",
      companyName: "重庆渝欧数字化智汇科技（集团）股份有限公司",
      stockCode: "股票代码：873017",
      companyIntroContent1:
        "重庆渝欧数字化智汇科技（集团）股份有限公司（股票代码：873017），成立于2014年，是一家以家庭消费和母婴营养服务为基础，以AI、数据和系统机制为长期能力底座的数字科技公司。",
      companyIntroContent2:
        "公司专注于中国跨境电商进口和全渠道零售，涵盖产品采购、保税仓储、线上零售、渠道分销、技术服务和线下终端。",
      companyIntroContent3:
        "已与达能、雀巢、A2、美赞臣、雅培、飞利浦等全球领先品牌建立长期合作关系。",
      mission: "使命",
      missionDesc: "帮助每一个家庭都生得起、养得好",
      vision: "愿景",
      visionDesc:
        "成为以长期用户价值为中心，由AI、系统和机制运营，持续自我进化的能力型公司",
      values: "核心价值观",
      valuesDesc: "客户第一、团队合作、拥抱变化、激情、诚信、开放",
    },
    policy: {
      manual: "产品说明书",
      privacyTitle: "隐私政策",
      refundTitle: "退款政策",
    },
    policyPages: {
      privacy: {
        title: "隐私政策",
      },
      refund: {
        title: "退款政策",
      },
    },
    refund: {
      title: "退货、退款与换货政策",
      section1Title: "退货政策",
      s1Intro: "您可在收到产品之日起 7 个自然日内申请退货。",
      s1EligibilityIntro: "符合退货条件需同时满足以下要求：",
      s1e1: "在收到产品后 7 个自然日内提交退货申请；",
      s1e2: "产品未使用，或产品状态不影响二次销售；",
      s1e3: "产品本体、原包装、配件、赠品、说明书及随附物品齐全且完好；",
      s1e4: "可提供有效订单记录、购买凭证或付款证明。",
      s1Note:
        "退货前请先联系客服确认退货流程及退货地址。未经确认自行寄回的产品可能无法被正常处理。",
      section2Title: "退款政策",
      s2p1: "我们收到并检验退回产品后，将通过电子邮件或其他联系方式通知您退款审核结果。",
      s2p2: "若退款申请获批，退款将在 3–5 个工作日内退回至您的原支付账户。实际到账时间可能因银行或支付平台处理时效而有所不同。",
      s2p3: "符合退货退款条件的，不另行收取手续费。",
      section3Title: "换货政策",
      s3Intro: "在收到产品之日起 7 个自然日内，如出现以下情形可申请换货：",
      s3e1: "收货时发现产品损坏；",
      s3e2: "产品存在非人为因素导致的质量问题；",
      s3e3: "产品与原始产品描述存在实质性不符；",
      s3e4: "产品因非人为损坏导致性能故障；",
      s3e5: "产品在运输过程中损坏，并可提供物流公司或承运方出具的有效损坏证明。",
      s3Note:
        "申请换货前请先联系客服确认换货流程。换货申请确认后，请在 7 个自然日内退回相应产品。",
      section4Title: "不支持退货、退款或换货的情形",
      s4Intro: "在以下任一情形下，我们保留拒绝退货、退款或换货申请的权利：",
      s4i1: "申请在收到产品超过 7 个自然日后提交；",
      s4i2: "产品、包装、配件、赠品、说明书或其他随附物品不完整或损坏；",
      s4i3: "产品存在人为损坏，如碰撞、灼烧、跌落或不当使用；",
      s4i4: "产品未经授权被拆卸、改装、维修或改动；",
      s4i5: "因水、油、沙、异物、安装不当或未按说明书使用导致损坏；",
      s4i6: "产品标签、序列号、防水标识、防伪标识等被移除、涂改或损坏；",
      s4i7: "因火灾、洪水、雷击、交通事故等不可抗力导致损坏；",
      s4i8: "无法提供有效购买凭证，或所提供的凭证系伪造、涂改；",
      s4i9: "经检验确认产品无质量问题；",
      s4i10: "联系客服并确认退货或换货流程后，未在 7 个自然日内退回产品；",
      s4i11: "定制或个性化产品无质量问题的不支持退货或换货；",
      s4i12: "本政策规定的其他不支持退货、退款或换货的情形。",
      section5Title: "退货运费",
      s5Intro: "退货或换货的运费将根据问题原因确定。",
      s51Title: "5.1 由卖方原因导致的问题",
      s51Desc:
        "若问题由卖方导致，如产品质量问题、严重损坏、无法正常使用、发错货、漏发或与产品描述严重不符：",
      s51b1: "买方须按指引退回产品；",
      s51b2: "退货运费由卖方承担；",
      s51b3: "重新发货费用由卖方承担。",
      s52Title: "5.2 由买方原因导致的问题",
      s52Desc:
        "若退货由买方原因导致，如个人偏好、不满意、选错颜色或规格，或不影响正常使用的轻微瑕疵：",
      s52b1: "买方须按指引退回产品；",
      s52b2: "退货运费由买方承担；",
      s52b3: "如涉及重新发货，费用安排以客服确认为准。",
      s53Title: "5.3 由物流或运输导致的问题",
      s53Desc: "若产品在运输过程中因物流原因损坏或破损，并影响正常使用：",
      s53b1: "买方须按指引退回产品；",
      s53b2: "退货运费由卖方承担；",
      s53b3: "重新发货费用由卖方承担；",
      s53b4:
        "买方须提供有效证明，如物流公司或承运方出具的损坏证明、照片或视频。",
      section6Title: "如何申请退货、退款或换货",
      s6Intro: "申请退货、退款或换货时，请联系客服并提供以下信息：",
      s6i1: "订单号；",
      s6i2: "购买凭证或付款证明；",
      s6i3: "退货、退款或换货原因；",
      s6i4: "如适用，请提供产品问题的照片或视频；",
      s6i5: "若产品在运输过程中损坏，请提供物流公司或承运方出具的损坏证明。",
      s6Note:
        "请勿在未联系客服确认的情况下自行退货。未经确认退回的产品可能无法被正常处理。",
      section7Title: "重要提示",
      s7p1: "退回产品须寄送至客服确认的地址。因寄送至错误地址或未经确认自行退回导致产品丢失、延误或无法处理，相关责任由用户承担。",
      s7p2: "所有退货、退款及换货申请，均以我们收到产品后的最终检验与审核结果为准。",
    },
    faq: {
      title: "常见问题",
      answer: wifiAnswer.zh,
      section1Title: "产品定位",
      s1q1: "yoyo 是什么？",
      s1a1: "yoyo 是一款专为亲子家庭打造的互动陪伴机器人。通过表情、灯光、声音和简单互动，为宝宝和家庭成员提供日常陪伴、睡前安抚、讲故事和成长记录等功能。",
      s1q2: "yoyo 会取代父母陪伴宝宝吗？",
      s1a2: "不会。yoyo 的设计目的不是取代父母，而是支撑亲子陪伴。它帮助将互动引导回家庭，使宝宝与家庭成员之间的情感联结更加自然、稳定。",
      section2Title: "设备连接与管理",
      s2q1: "如何添加 yoyo 设备？",
      s2a1: "打开 App，进入「yoyo 管理」，点击右上角扫描按钮扫描 yoyo 设备上显示的绑定二维码即可。",
      s2q2: "一个账号可以绑定多个 yoyo 设备吗？",
      s2a2: "可以。如果家中有多个设备，可以在 App 中分别添加和管理。",
      s2q3: "yoyo 是否支持网络重新配置？",
      s2a3: "支持。当家庭 Wi-Fi 变更、设备离线或连接异常时，可以直接在 yoyo 设备上重新配置网络。",
      section3Title: "陪伴与互动",
      s3q1: "yoyo 能和宝宝说话吗？",
      s3a1: "可以。yoyo 支持语音互动。宝宝或家长可以通过语音唤醒并与它交流。",
      s3q2: "yoyo 支持连续对话吗？",
      s3a2: "可以。yoyo 支持基础的连续对话。在互动过程中，它能根据上下文做出回应，同时保持整体体验克制，避免过度刺激或过度互动。",
      s3q3: "yoyo 能讲故事吗？",
      s3a3: "可以。yoyo 支持故事播放，并能根据宝宝的偏好逐步推荐更合适的故事。",
      s3q4: "yoyo 能播放音乐或白噪音吗？",
      s3a4: "可以。yoyo 可用于睡前放松、安抚和陪伴，支持轻柔的声音、音乐、白噪音等内容。",
      s3q5: "yoyo 会一直主动打扰用户吗？",
      s3a5: "不会。yoyo 遵循低打扰、低刺激、可控的原则。它不会频繁争夺注意力，而是根据情况温和回应。",
      section4Title: "情绪安抚与睡前陪伴",
      s4q1: "宝宝哭闹时，yoyo 会做什么？",
      s4a1: "yoyo 不会强行打断宝宝的情绪。它会使用柔和的灯光、平静的表情和低刺激的声音，帮助宝宝的情绪逐渐平复。",
      s4q2: "yoyo 能识别宝宝的情绪吗？",
      s4a2: "yoyo 可以结合语音强度、环境声音、互动状态等信息来理解当前场景和情绪变化，然后提供更温和的陪伴反馈。",
      s4q3: "yoyo 可以在睡前使用吗？",
      s4a3: "可以。睡前是 yoyo 一代的重要场景。通过温暖的灯光、轻柔的声音和平静的陪伴，帮助宝宝和家人进入更稳定的睡前节奏。",
      section5Title: "灯光与声音",
      s5q1: "可以调节灯光亮度吗？",
      s5a1: "可以。家长可在 App 中设置灯光开关和亮度。",
      s5q2: "可以调节 yoyo 的音量吗？",
      s5a2: "可以。可在 App 中查看和调节设备音量。",
      section6Title: "家庭记忆与成长记录",
      s6q1: "家长可以查看互动记录吗？",
      s6a1: "可以。家长可在 App 中查看宝宝与 yoyo 的互动记录、对话摘要、故事播放记录和陪伴总结。",
      s6q2: "yoyo 能生成陪伴总结吗？",
      s6a2: "可以。系统可根据日常互动生成总结，帮助家长了解宝宝近期的互动状态和陪伴偏好。",
      section7Title: "安全与隐私",
      s7q1: "yoyo 会一直录音吗？",
      s7a1: "不会。yoyo 的音频功能主要用于唤醒、互动和场景理解，并非为持续监听而设计。家长可以在 App 中管理相关设置。",
      s7q2: "宝宝的数据安全吗？",
      s7a2: "yoyo 的设计符合儿童隐私和家庭数据安全要求。用户可以查看隐私政策、儿童个人信息保护规则和服务协议。",
    },
    notFound: {
      title: "404",
      subtitle: "抱歉，页面不存在或已被移动。",
      back: "返回上一页",
      home: "回到首页",
    },
  },
  en: {
    common: {
      buyNow: "Buy Now",
      viewProducts: "View Products",
      shopNow: "Shop Now >",
      menu: "Menu",
      hotline: "Hotline",
      email: "Email",
      address: "Address",
    },
    nav: {
      products: "Products",
      support: "Support",
      about: "About",
      yoyo: "yoyo",
      threeInOne: "Three-in-one",
      faq: "FAQ",
      contact: "Contact Us",
      manual: "Product Manual",
      privacy: "Privacy Policy",
      refund: "Refund Policy",
      langZh: "中文",
      langEn: "English",
      switchToEn: "English",
      switchToZh: "中文",
    },
    home: {
      heroTitle:
        "Built for 0-3 year old babies and families — understands emotions, remembers, grows with your baby",
      ourProducts: "Our Products",
      brandHeadline: "We carry emotions, but don't possess them.",
      brandPhilosophy:
        "We believe technology should serve emotional connections within families. YOYO is not a cold machine, but a companion that understands emotions and remembers. We carry emotions, but don't possess them — every interaction helps it understand your family better.",
      feature1Title:
        "Every interaction makes it understand this family better.",
      feature2Title:
        "We don't pursue high power, high performance, and strong interaction.",
      brandCertTitle: "Brand Introduction & Certificates",
      brandCertSubtitle: "Title",
      certificate: "Certificate",
      companyIntro: "Company Introduction",
      heroSlide2Title: "Understands emotions, remembers, grows with your baby",
      categorySectionTitle: "Find The Best Fit For Your Baby",
      categoryYoyo: "yoyo Gen 1",
      categoryYoyoDesc: "Smart Companion",
      categoryThreeInOneDesc: "Family scene bundle",
      categoryApp: "YOYO App",
      categoryAppDesc: "Growth & evolution",
      categorySupport: "Support",
      categorySupportDesc: "FAQ & product manual",
      featuresSectionTitle: "yoyo Smart Companion Features",
      testimonialsTitle: "What Families Say",
      brandStoryTitle: "Warm AI companionship for ages 0-3",
      brandStoryDesc:
        "YOYO focuses on emotional changes, tells stories with familiar voices, and understands your family through every interaction. We don't chase feature overload — we build a trusted long-term companion.",
      pressTitle: "Press & Partners",
      review1Author: "Lisa M.",
      review1Text:
        "My baby loves yoyo. Bedtime stories every night — moods are noticeably calmer.",
      review2Author: "James W.",
      review2Text:
        "Voice cloning is a game-changer. Even when traveling, baby hears familiar voices.",
      review3Author: "Sarah C.",
      review3Text:
        "The growth logs in the app are clear. Weekly reports help us understand our baby better.",
      review4Author: "Michael Z.",
      review4Text:
        "Beautiful build, easy setup. Grandparents can bind the device without trouble.",
      review5Author: "Emily K.",
      review5Text:
        "Support responds fast. Wi-Fi setup and warranty questions were handled quickly.",
      review6Author: "David L.",
      review6Text:
        "yoyo never feels intrusive — just the right amount of companionship for our family.",
      featSmart: "Smart",
      featSmartDesc: "Emotion sensing / Memory / Family fit",
      featVoice: "Voice",
      featVoiceDesc: "Parent voice stories / Multi-language",
      featGrowth: "Growth",
      featGrowthDesc: "Diary / Weekly log / Evolution",
      featSafety: "Safety",
      featSafetyDesc: "Encryption / Child privacy",
      featConnect: "Connect",
      featConnectDesc: "Wi-Fi setup / Remote App control",
      featService: "Service",
      featServiceDesc: "Free shipping / 1-year warranty / 24/7 support",
    },
    product: {
      name: "yoyo Gen 1",
      description: "yoyo Smart Companion",
      price: "¥1000.00 CNY",
      details: "Details",
      faqs: "FAQS",
      brandPhilosophy: "Brand Philosophy",
      attributes: "Product Attributes",
      usageScenarios: "Usage Scenarios",
      appGrowth: "APP Growth Evolution Record",
      evolution: "How it Evolves",
      heroTitle: "yoyo Parent-Child Companion Robot",
      heroDesc:
        "for Babies 0-3 with Emotional Support, Sleep Soothing and Storytelling",
      afterSales:
        "If you have any after-sales issues, please contact customer service",
      preSaleNote:
        "Pre-sale items are expected to be shipped before August 30, 2026",
      preSale: "Pre-sale",
      usdPrice: "$58.65 USD",
      colorOffWhite: "Off-white",
      colorSpaceGray: "Space Gray",
      sizeS: "Gen 1-S",
      sizeM: "Gen 1-M",
      spec1: "Spec 1",
      spec2: "Spec 2",
      spec3: "Spec 3",
      attrProductSize: "Product Size",
      attrPackageSize: "Package Size",
      attrProductSizeValue: "120 × 120 × 80 mm",
      attrPackageSizeValue: "200 × 200 × 150 mm",
      listen: "Listen",
      see: "See",
      speak: "Speak",
      think: "Think",
      move: "Move",
      featureEmotionalTitle: "Emotional Companionship",
      featureEmotionalDesc:
        "Focus on baby's emotional changes with warm companionship",
      featureStoryTitle: "Parents' Voices Telling Stories",
      featureStoryDesc:
        "Tell stories with familiar voices for a sense of security",
      featureEducationTitle: "Self-education",
      featureEducationDesc: "Accompany babies to explore and grow",
      appFeature1: "Home Evolution Bubbles",
      appFeature2: "Diary",
      appFeature3: "Weekly Log",
      appFeature4: "Baby Emotion Manager",
      appFeature5: "Family Relationship Activation",
      stageRecord: "Record",
      stageRecordDesc: "Record every interaction and emotion",
      stageUnderstand: "Understand",
      stageUnderstandDesc: "Understand baby's emotions and needs",
      stageRemember: "Remember",
      stageRememberDesc: "Remember the family's unique habits",
      stageFeedback: "Feedback",
      stageFeedbackDesc: "Provide appropriate feedback and responses",
      stageEvolve: "Evolve",
      stageEvolveDesc: "Continuously evolve to understand the family better",
    },
    service: {
      freeShipping: "Free Shipping",
      freeShippingDesc: "Free nationwide delivery",
      customerService: "service",
      customerServiceDesc: "24/7 online support",
      securePayment: "Secure Payment",
      securePaymentDesc: "Multiple secure payment options",
      warranty: "30-days Return Policy",
      hour24: "Response in 24 Hrs",
      warrantyDesc: "One-year warranty",
      customerFirst: "Customer First",
      customerFirstDesc: "Family needs come first",
      freeShippingHomeDesc: "Free nationwide delivery",
    },
    contact: {
      heroAlt: "yoyo Parent-Child Companion Robot",
      heroTitle: "yoyo Parent-Child Companion Robot",
      heroSubtitle:
        "yoyo is with you — the longer she's with you, the more she understands you.",
      infoTitle: "Contact information",
      messageTitle: "Leave a message",
      hotline: "Hotline",
      contactLabel: "Contact: ",
      emailLabel: "Email: ",
      addressLabel: "Address: ",
      address:
        "Tangli, Ma'anshan, Zaozilan'ya Zhengjie, Yuzhong District, Chongqing, China",
      formEmail: "E-mail",
      formPhone: "Phone Number",
      formName: "Name",
      formMessage: "Information",
      formSend: "Send",
      formEmailRequired: "Please enter email",
      formEmailInvalid: "Invalid email",
      formPhoneRequired: "Please enter phone",
      formNameRequired: "Please enter name",
      formMessageRequired: "Please enter message",
      formSuccess: "Message sent successfully",
      formError: "Message sending failed",
      formcontactRequired: "Please enter a valid contact",
      formcontact: "E-mail",
    },
    about: {
      heroAlt: "Chongqing cityscape",
      parkAlt: "YUOU Cross-border Digital Trade Industrial Park",
      companyName:
        "Chongqing Yuou Digital Intelligence Technology (Group) Co., Ltd.",
      stockCode: "Stock Code: 873017",
      companyIntroContent1:
        "Chongqing Yuou Intelligence Technology Group was established in 2014 and is a digital intelligence technology enterprise built on family consumption and maternal & infant nutrition and health services, with AI, data, and system-driven operations serving as its long-term core capabilities.",
      companyIntroContent2:
        "The company has extensive experience in cross-border e-commerce imports and domestic omnichannel retail operations. It has developed an integrated supply chain service system covering product sourcing, bonded warehousing, e-commerce retail, channel distribution, technology services, and offline retail network operations.",
      companyIntroContent3:
        "The company has also established long-term partnerships with internationally renowned brands including Danone, Nestlé, a2 Milk Company, Mead Johnson, Abbott, and Philips.",
      mission: "Mission",
      missionDesc:
        "To help every family raise healthier and happier children through accessible, trustworthy, and professional maternal and infant care solutions.",
      vision: "Vision",
      visionDesc:
        "To become an AI-powered, capability-driven organization that continuously evolves while creating long-term value for users.",
      values: "Core Values",
      valuesDesc:
        "Customer First · Teamwork · Embrace Change · Passion · Integrity · Openness",
    },
    policy: {
      manual: "Product Manual",
      privacy: "Privacy Policy",
      refund: "Refund Policy",
    },
    refund: {
      title: "Return, Refund, and Exchange Policy",
      section1Title: "Return Policy",
      s1Intro:
        "You may apply for a return within 7 calendar days from the date you receive the product.",
      s1EligibilityIntro:
        "To be eligible for a return, the following conditions must be met:",
      s1e1: "The return request is submitted within 7 calendar days after receiving the product;",
      s1e2: "The product is unused, or its condition does not affect resale;",
      s1e3: "The product itself, original packaging, accessories, gifts, manuals, and all included items are complete and undamaged;",
      s1e4: "A valid order record, purchase receipt, or proof of payment can be provided.",
      s1Note:
        "Before returning the product, please contact customer service to confirm the return process and return address. Products returned without prior confirmation may not be properly processed.",
      section2Title: "Refund Policy",
      s2p1: "After we receive and inspect the returned product, we will notify you of the refund review result by email or other contact methods.",
      s2p2: "If the refund request is approved, the refund will be returned to your original payment account within 3–5 business days. The actual arrival time may vary depending on the processing time of your bank or payment platform.",
      s2p3: "No additional handling fee will be charged for eligible returns and refunds.",
      section3Title: "Exchange Policy",
      s3Intro:
        "You may apply for an exchange within 7 calendar days from the date you receive the product if any of the following situations occur:",
      s3e1: "The product is found damaged upon receipt;",
      s3e2: "The product has quality issues not caused by human factors;",
      s3e3: "The product is materially inconsistent with the original product description;",
      s3e4: "The product has a performance failure caused by non-human damage;",
      s3e5: "The product is damaged during transportation, and valid proof of damage issued by the logistics company or carrier can be provided.",
      s3Note:
        "Before applying for an exchange, please contact customer service to confirm the exchange process. After the exchange request is confirmed, please return the corresponding product within 7 calendar days.",
      section4Title:
        "Situations Where Returns, Refunds, or Exchanges Are Not Supported",
      s4Intro:
        "We reserve the right to refuse a return, refund, or exchange request under any of the following circumstances:",
      s4i1: "The request is submitted more than 7 calendar days after receiving the product;",
      s4i2: "The product, packaging, accessories, gifts, manuals, or other included items are incomplete or damaged;",
      s4i3: "The product has human-caused damage, such as collision, burning, dropping, or misuse;",
      s4i4: "The product has been disassembled, modified, repaired, or altered without authorization;",
      s4i5: "Damage is caused by water, oil, sand, foreign objects, improper installation, or failure to use the product according to the manual;",
      s4i6: "Product labels, serial numbers, waterproof marks, anti-counterfeiting marks, or similar identifiers are removed, altered, or damaged;",
      s4i7: "The product is damaged due to force majeure events such as fire, flood, lightning strike, or traffic accident;",
      s4i8: "A valid proof of purchase cannot be provided, or the provided proof is forged or altered;",
      s4i9: "The product is inspected and confirmed to have no quality issue;",
      s4i10:
        "The product is not returned within 7 calendar days after contacting customer service and confirming the return or exchange process;",
      s4i11:
        "Customized or personalized products are not eligible for returns or exchanges without quality issues;",
      s4i12:
        "Other situations specified in this policy where returns, refunds, or exchanges are not supported.",
      section5Title: "Return Shipping Costs",
      s5Intro:
        "Shipping costs for returns or exchanges will be determined based on the cause of the issue.",
      s51Title: "5.1 Issues Caused by the Seller",
      s51Desc:
        "If the issue is caused by the seller, such as product quality problems, serious damage, inability to function properly, wrong item, missing item, or inconsistency with the product description:",
      s51b1: "The buyer is required to return the product as instructed;",
      s51b2: "Return shipping costs will be covered by the seller;",
      s51b3: "Reshipping costs will be covered by the seller.",
      s52Title: "5.2 Issues Caused by the Buyer",
      s52Desc:
        "If the return is caused by the buyer, such as personal preference, dissatisfaction, choosing the wrong color and specification, or minor defects that do not affect normal use:",
      s52b1: "The buyer is required to return the product as instructed;",
      s52b2: "Return shipping costs will be covered by the buyer;",
      s52b3:
        "If reshipping is involved, the cost arrangement shall be subject to customer service confirmation.",
      s53Title: "5.3 Issues Caused by Logistics or Transportation",
      s53Desc:
        "If the product is damaged or broken during transportation due to logistics reasons and its normal use is affected:",
      s53b1: "The buyer is required to return the product as instructed;",
      s53b2: "Return shipping costs will be covered by the seller;",
      s53b3: "Reshipping costs will be covered by the seller;",
      s53b4:
        "The buyer is required to provide valid proof, such as a damage certificate issued by the logistics company or carrier, photos, or videos.",
      section6Title: "How to Apply for a Return, Refund, or Exchange",
      s6Intro:
        "To apply for a return, refund, or exchange, please contact customer service and provide the following information:",
      s6i1: "Order number;",
      s6i2: "Purchase receipt or proof of payment;",
      s6i3: "Reason for return, refund, or exchange;",
      s6i4: "Photos or videos of the product issue, if applicable;",
      s6i5: "If the product was damaged during transportation, please provide a damage certificate issued by the logistics company or carrier.",
      s6Note:
        "Please do not return the product without first contacting customer service for confirmation. Products returned without confirmation may not be properly processed.",
      section7Title: "Important Notes",
      s7p1: "Returned products must be sent to the address confirmed by customer service. If the product is lost, delayed, or cannot be processed due to being sent to the wrong address or returned without prior confirmation, the user shall bear the relevant responsibility.",
      s7p2: "All return, refund, and exchange requests are subject to the final inspection and review results after we receive the product.",
    },
    faq: {
      title: "Common questions",
      answer: wifiAnswer.en,
      section1Title: "Product Positioning",
      s1q1: "What is yoyo?",
      s1a1: "yoyo is an interactive companion robot designed for parent-child families. Through expressions, lights, sound, and simple interactions, it supports daily companionship, bedtime soothing, storytelling, and growth recording for babies and family members.",
      s1q2: "Will yoyo replace parents in accompanying the baby?",
      s1a2: "No. yoyo is not designed to replace parents, but to support parent-child companionship. It helps guide interactions back to the family, making bonding between the baby and family members more natural and stable.",
      section2Title: "Device Connection and Management",
      s2q1: "How do I add a yoyo device?",
      s2a1: 'Open the App, go to "yoyo Management," and tap the scan button in the upper right corner to scan the binding QR code displayed on the yoyo device.',
      s2q2: "Can one account bind multiple yoyo devices?",
      s2a2: "Yes. If there are multiple devices at home, they can be added and managed separately in the App.",
      s2q3: "Does yoyo support network reconfiguration?",
      s2a3: "Yes. When the home Wi-Fi changes, the device goes offline, or the connection becomes abnormal, you can reconfigure the network directly on the yoyo device.",
      section3Title: "Companionship and Interaction",
      s3q1: "Can yoyo talk with the baby?",
      s3a1: "Yes. yoyo supports voice interaction. Babies or parents can wake it up and communicate with it by voice.",
      s3q2: "Does yoyo support continuous conversation?",
      s3a2: "Yes. yoyo supports basic continuous conversation. During interactions, it can respond based on the context, while keeping the overall experience restrained and avoiding overstimulation or excessive interaction.",
      s3q3: "Can yoyo tell stories?",
      s3a3: "Yes. yoyo supports story playback and can gradually recommend more suitable stories based on the baby's preferences.",
      s3q4: "Can yoyo play music or white noise?",
      s3a4: "Yes. yoyo can be used for bedtime relaxation, soothing, and companionship, supporting gentle sounds, music, white noise, and similar content.",
      s3q5: "Will yoyo actively disturb users all the time?",
      s3a5: "No. yoyo follows the principles of low interruption, low stimulation, and controllability. It does not frequently compete for attention, but responds gently based on the situation.",
      section4Title: "Emotional Soothing and Bedtime Companionship",
      s4q1: "What will yoyo do when the baby cries?",
      s4a1: "yoyo will not forcefully interrupt the baby's emotions. Instead, it uses soft lighting, calm expressions, and low-stimulation sounds to help the baby's emotions gradually settle down.",
      s4q2: "Can yoyo recognize the baby's emotions?",
      s4a2: "yoyo can combine voice intensity, environmental sounds, interaction status, and other information to understand the current scene and emotional changes, then provide gentler companionship feedback.",
      s4q3: "Can yoyo be used at bedtime?",
      s4a3: "Yes. Bedtime is an important scenario for yoyo's first generation. With dim warm lighting, gentle sounds, and calm companionship, it helps the baby and family enter a more stable bedtime rhythm.",
      section5Title: "Lights and Sound",
      s5q1: "Can the light brightness be adjusted?",
      s5a1: "Yes. Parents can set the light switch and brightness in the App.",
      s5q2: "Can yoyo's volume be adjusted?",
      s5a2: "Yes. The device volume can be viewed and adjusted in the App.",
      section6Title: "Family Memory and Growth Records",
      s6q1: "Can parents view interaction records?",
      s6a1: "Yes. Parents can view the baby's interaction records with yoyo, conversation summaries, story playback records, and companionship summaries in the App.",
      s6q2: "Can yoyo generate companionship summaries?",
      s6a2: "Yes. The system can generate summaries based on daily interactions, helping parents understand the baby's recent interaction status and companionship preferences.",
      section7Title: "Safety and Privacy",
      s7q1: "Will yoyo record audio all the time?",
      s7a1: "No. yoyo's audio capability is mainly used for wake-up, interaction, and scene understanding. It is not designed for continuous listening. Parents can manage related settings in the App.",
      s7q2: "Is the baby's data safe?",
      s7a2: "yoyo is designed in accordance with children's privacy and family data security requirements. Users can view the Privacy Policy, Children's Personal Information Protection Rules, and Service Agreement.",
    },
    notFound: {
      title: "404",
      subtitle: "Sorry, the page does not exist or has been moved.",
      back: "Go Back",
      home: "Back to Home",
    },
    policyPages: {
      privacy: {
        title: "Privacy Policy",
      },
      refund: {
        title: "Refund Policy",
      },
    },
  },
} as const;

export type LangMessages = (typeof lang)[Locale];

/** 通过 locale + 点路径获取文案，如 t("zh", "home.heroTitle") */
export function t(locale: Locale, key: string): string {
  const keys = key.split(".");
  let value: unknown = lang[locale];
  for (const k of keys) {
    if (value == null || typeof value !== "object") return key;
    value = (value as Record<string, unknown>)[k];
  }
  return typeof value === "string" ? value : key;
}

/** 获取当前语言完整文案对象 */
export function getLang(locale: Locale): LangMessages {
  return lang[locale];
}
